/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
// import { ModalContext } from 'App';
import ReactTooltip from 'react-tooltip';
import * as actions from '../action';
import * as c from '../constant';

// import MenuSidebarListModal from './components/MenuSidebarListModal';

const CMS_TYPE = 'E-VERIFY';

const fields = [
  'ENABLED',
  'TEST_CASE',
  'BYPASS_EVERIFICATION'
];

const menuSidebarfields = [
  'DASHBOARD',
  'SUBSCRIBERS',
  'CITIZEN',
  'GOMANILA_SERVICES',
  // subs
  'RPT_SERVICES_SUB_MENU',
  'BPLS_SERVICES_SUB_MENU',
  'CEDULA_SERVICES_SUB_MENU',
  'CIVIL_REGISTRY_SERVICES_SUB_MENU',
  'OHP_SERVICES_SUB_MENU',
  'HEALTH_CERTIFICATE_SERVICES_SUB_MENU',
  'OCCUPATIONAL_PERMIT_SERVICES_SUB_MENU',
  'POLICE_CLEARANCE_SERVICES_SUB_MENU',
  'REAL_PROPERTY_TAX_SERVICES_SUB_MENU',
  'BTAX_SERVICES_SUB_MENU',
  'OVRS_SERVICES_SUB_MENU',
  'NOVS_SERVICES_SUB_MENU',
  'DELIVERY_TRANSACTIONS_SERVICES_SUB_MENU',
  'SOCIAL_AMELIORATION_SENIOR_CITIZENS_SERVICES_SUB_MENU',
  'REPORTS_SERVICES_SUB_MENU',
  'BPLS_REPORTS_SERVICES_SUB_MENU',
  'GCASH_REPORTS_SERVICES_SUB_MENU',
  'PAYMENT_REPORTS_SERVICES_SUB_MENU',
  'SOCIAL_AMELIORATIONS_REPORTS_SERVICES_SUB_MENU',
  'BILLINGS_REPORTS_SERVICES_SUB_MENU',
  'QR_CODE_REPORTS_SERVICES_SUB_MENU',

  'E_COMMERCE',
  'E_BILLS_PAYMENT',
  'E_SERVICES',
  'E_NEWS',
  'ARTICLES_NEWS_SUB_MENU',
  'E_WALLET_SERVICES',
  // subs
  'E_BILLS_E_WALLET_SERVICES_SUB_MENU',
  'CASH_IN_E_WALLET_SERVICES_SUB_MENU',
  'CASH_TRANSFER_E_WALLET_SERVICES_SUB_MENU',
  'RECEIVED_FUND_E_WALLET_SERVICES_SUB_MENU',
  'MOBILE_LOAD_E_WALLET_SERVICES_SUB_MENU',
  'E_WALLET_SUPPORT_E_WALLET_SERVICES_SUB_MENU',

  'E_HELP',
];

function Everify({
  getList,
  createSelect,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
  createInput,
  createUploader,
  getCms,
}) {
  // const setModal = useContext(ModalContext);

  // const onHandleMenuSidebarList = e => {
  //   e.preventDefault();

  //   setModal({
  //     isOpen: true,
  //     content: <MenuSidebarListModal
  //       formData={formData}
  //       setFormData={setFormData}
  //       item={item}
  //       fields={fields}
  //       menuSidebarfields={menuSidebarfields}
  //     />,
  //     title: 'HIDE SIDE MENU ITEMS',
  //     modalSize: 'modal-lg',
  //   });
  // };

  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(
        _.get(formData, 'id'),
        {
          body: JSON.stringify(
            _.pick(formData, [...fields, ...menuSidebarfields])
          ),
        },
        () => getCms()
      );
    }

    return create(
      {
        body: JSON.stringify(
          _.pick(formData, [...fields, ...menuSidebarfields])
        ),
      },
      () => getCms()
    );
  };

  const renderToolTip = (fieldId = '', label = 'enter text here') => {
    return (
      <>
        <i
          className="fa fa-question-circle pl-2 my-auto text-warning"
          data-tip=""
          data-for={fieldId}
        />
        <ReactTooltip
          place="top"
          id={fieldId}
          type="dark"
          effect="float"
          delayShow="300"
        >
          <div className="">
            {label}
            {/* <img src="" alt="img" /> // todo later: add image here from cms */}
          </div>
        </ReactTooltip>
      </>
    );
  };

  return (
    <div className="card border shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleOnSubmit}>
          {createHidden({ key: 'id' }, { placeholder: '' })}
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">E-Verify Settings</h5>
              <p className="mb-0 text-muted">
                Configure subscribers verification settings and test controls.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-3">
              <div className="border rounded bg-white shadow-sm p-3 mb-0">
                <div className="form-group group-cms-color mb-2">
                  <b>SUBSCRIBERS</b>
                </div>
                <div className="form-group group-cms-color d-flex mb-2">
                  {createCheckbox(
                    { key: 'ENABLED', label: 'ENABLED' },
                    { className: 'd-flex align-items-center align-self-center' }
                  )}
                </div>
                <div className="form-group group-cms-color d-flex mb-2">
                  {createCheckbox(
                    { key: 'TEST_CASE', label: 'TEST CASE' },
                    { className: 'd-flex align-items-center align-self-center' }
                  )}
                </div>
                <div className="form-group group-cms-color d-flex mb-0">
                  {createCheckbox(
                    { key: 'BYPASS_EVERIFICATION', label: 'BYPASS EVERIFICATION' },
                    { className: 'd-flex align-items-center align-self-center' }
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center pt-2">
            <button
              // disabled={creating}
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

Everify.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  getCms: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Everify);
